import type { Environment } from 'src/types';

export const prepareResumeDataForUpload = ({
  data,
  file,
  environment,
  mockApiUrl,
}: {
  data: any;
  file: File;
  environment: Environment;
  mockApiUrl: string;
}): { url: string; formData: FormData } => {
  const { link, formFields } = data.viewer.documentUploadFormData;
  const url =
    environment === 'local' || environment === 'test'
      ? `${mockApiUrl}/resumes`
      : link;
  const formData = new FormData();

  formFields.forEach((field: { key: string; value: string }) => {
    if (field && field.key && field.value) {
      formData.append(field.key, field.value);
    }
  });

  formData.append('file', file);

  return { url, formData };
};
